var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChoose4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291",
    transform: "translate(-5950 -2094)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(5950 2094)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(5975.005 2117.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3960_",
    transform: "translate(5.572 6.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M27.694,52.612a.977.977,0,0,1-.811-.432l-6.67-9.928a.978.978,0,0,1-.147-.739l3.5-17.308,1.916.387L22.063,41.5l5.631,8.382L33.325,41.5,29.909,24.592a.98.98,0,0,1,.1-.666l1.368-2.487,1.712.943-1.2,2.173,3.426,16.956a.978.978,0,0,1-.147.739L28.5,52.179a.974.974,0,0,1-.81.433Z",
    transform: "translate(-5.899 -7.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M27.747,25.375H24.573a.979.979,0,0,1-.841-.479l-1.208-2.038a.977.977,0,1,1,1.682-1l.924,1.559h2.616a.977.977,0,1,1,0,1.954Z",
    transform: "translate(-5.952 -7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M27.847,53.058a.977.977,0,0,1-.81-1.523l6.67-9.928A.978.978,0,1,1,35.329,42.7l-6.67,9.928a.978.978,0,0,1-.812.432Z",
    transform: "translate(-6.053 -7.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M24.273,47.137a.977.977,0,0,1-.811-1.521l5.515-8.248A.977.977,0,1,1,30.6,38.455L25.087,46.7a.975.975,0,0,1-.813.434Z",
    transform: "translate(-5.972 -7.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M26,35.906a.978.978,0,0,1-.814-1.517l5.218-7.9a.977.977,0,1,1,1.63,1.078l-5.217,7.9A.976.976,0,0,1,26,35.906Z",
    transform: "translate(-6.011 -7.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M20.77,25.05l-.077,0a.978.978,0,0,1-.757-.465l-7.39-12.108a.976.976,0,0,1,.152-1.209l4.434-4.32a.977.977,0,0,1,1.46.109c.627.623,6.23,5.324,9.68,8.2a.977.977,0,0,1,.119,1.385l-6.878,8.071A.981.981,0,0,1,20.77,25.05ZM14.62,12.121,20.9,22.412l5.361-6.292c-4.976-4.143-7.326-6.106-8.434-7.125Z",
    transform: "translate(-5.726 -6.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M34.855,25.05a.974.974,0,0,1-.744-.344l-6.879-8.071a.977.977,0,0,1,.119-1.385c3.45-2.873,9.054-7.574,9.68-8.2a.978.978,0,0,1,1.461-.109l4.433,4.32a.977.977,0,0,1,.151,1.209l-7.39,12.108a.978.978,0,0,1-.757.465.653.653,0,0,1-.076,0Zm-5.493-8.93,5.361,6.292,6.282-10.291L37.8,9C36.688,10.014,34.339,11.976,29.362,16.119Z",
    transform: "translate(-6.056 -6.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M37.585,8.622H17.915a.977.977,0,1,1,0-1.955H37.584a.977.977,0,0,1,0,1.955Z",
    transform: "translate(-5.829 -6.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M18.943,46.619H13.214a2.809,2.809,0,0,1-2.769-2.408L5.6,16.017a2.753,2.753,0,0,1,2.117-3.13L12.7,11.21a.977.977,0,1,1,.625,1.852L8.365,14.733c-.921.332-.868.708-.83.982l4.841,28.2a.854.854,0,0,0,.839.754h5.729a.977.977,0,1,1,0,1.955Z",
    transform: "translate(-5.572 -6.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M42.453,46.619H36.724a.977.977,0,0,1,0-1.955h5.729a.845.845,0,0,0,.834-.724l4.851-28.255c.033-.244.086-.62-.854-.959l-4.992-1.681a.977.977,0,1,1,.625-1.852l5.011,1.688c2.137.77,2.259,2.276,2.141,3.105L45.218,44.241a2.8,2.8,0,0,1-2.765,2.378Z",
    transform: "translate(-6.254 -6.768)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose4);
export default __webpack_public_path__ + "static/media/choose4.aea9536c050c21f32ff2e36e20374903.svg";
export { ForwardRef as ReactComponent };